"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgShare2 = function SvgShare2(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M30 13a4 4 0 11-2.841 6.815l-5.309 3.097a4.003 4.003 0 010 2.175l5.312 3.095a4 4 0 11-1.01 1.727l-5.31-3.094a4 4 0 110-5.63l5.308-3.097A4.003 4.003 0 0130 13zm0 16c-.695 0-1.308.355-1.666.894a.77.77 0 01-.05.1l-.065.097-.033.066A2 2 0 1030 29zm-12-7a2 2 0 101.726 3.007l.024-.038c.16-.287.25-.618.25-.969a1.99 1.99 0 00-.274-1.006l-.007-.017A1.999 1.999 0 0018 22zm12-7a2 2 0 00-1.75 2.969l.024.037.007.017A1.999 1.999 0 0032 17a2 2 0 00-2-2z",
    id: "share-2_svg__a"
  }));
};

var _default = SvgShare2;
exports["default"] = _default;